/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

import React, { useState } from "react";
import { Button } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { useHistory, Link } from "react-router-dom/cjs/react-router-dom";
import Cookies from "js-cookie";
import { useNotification } from "../contexts/NotificationContext";
import LogoutDialog from "./LogoutDialog";

export default function Header() {
  const { isLoggedIn, logout } = useAuth();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const { setMessage, setIsOpen, setIsFailed } = useNotification();
  const history = useHistory();

  const handleLogout = () => {
    Cookies.remove("jwtToken");
    Cookies.remove("crew_token");
    Cookies.remove("admin-dashboard");
    logout();

    setMessage("You've succesfully logged out");
    setIsOpen(true);
    setIsFailed(false);

    setIsModalOpened(false);

    history.push("/");
  };

  const handleCloseModal = () => {
    setIsModalOpened(false);
  };

  return (
    <>
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #D9D9D9",
          padding: "0 24px",
          marginTop: "5px", marginBottom:"5px",
        }}
      >
        <Link to="/app">
          <img src="/logo192.png" height="60" alt="image" />
        </Link>

        {isLoggedIn && (
          <Button
            onClick={() => setIsModalOpened(true)}
            variant="outlined"
            sx={{
              color: "#6c757d",
              border: "1px solid #6c757d",
              textTransform: "none",
              "&:hover": {
                bgcolor: "#5c636a",
                color: "#ffffff",
                borderColor: "#5c636a",
              },
            }}
          >
            Log out
          </Button>
        )}
      </header>

      <LogoutDialog
        handleLogout={handleLogout}
        isOpened={isModalOpened}
        handleClose={handleCloseModal}
      />
    </>
  );
}
